module.exports = {
  /*
   * 标题
   */
  title: '“红色印记”馆藏革命主题陶瓷作品特展',

  /*
   * 简述
   */
  showResume: false,

  resume: {
    title: '“红色印记”馆藏革命主题陶瓷作品特展',
    desc: ''
  },

  /*
   * 联系人
   */

  showPhone: false,

  phone: {
    name: '',
    desc: '',
    address: ''
  },

  /*
   * 文件地址
   */
  appUrl: '93vr.com',

  /*
   * 子级目录文件名
   */
  publicPath: '/hsyj',

  /*
   * 是否开启 https
   */
  https: true,

  /*
   * PHP访问地址
   */
  apiUrl: 'php/new.php',

  /*
   * ifrmae访问地址
   */
  iframeUrl: '//my.93vr.com/show/index2.html?m=NJdAUMgs7Mh&help=0&play=1&qs=1&gt=0&hr=0',
  /*
   * 背景音乐访问地址
   */
  defaultMusic: '//matcdn.93vr.com/hsyj/bgmusic/bg.mp3',

  /*
   * 图标访问地址
   */
  defaultIcon: '',

  /*
   * 模型访问地址
   */
  defalutModel: '',

  /*
   * 封面状态
   */
  showthumb: true,

  /*
   * 封面 PC端
   */
  thumbPC: '//matcdn.93vr.com/hsyj/assets/thumb.jpg',

  /*
   * 封面 移动端
   */
  thumbMobile: '//matcdn.93vr.com/hsyj/assets/thumbMobile.jpg',

  bgmusic: {
    0: '//matcdn.93vr.com/hsyj/bgmusic/0.mp3',
    1: '//matcdn.93vr.com/hsyj/bgmusic/1.mp3',
    2: '//matcdn.93vr.com/hsyj/bgmusic/2.mp3',
    3: '//matcdn.93vr.com/hsyj/bgmusic/3.mp3',
    4: '//matcdn.93vr.com/hsyj/bgmusic/4.mp3',
    5: ''
  },

  videos: {
    '3WLtEWQqAun': {
      title: '新彩伟人',
      image: '//matcdn.93vr.com/hsyj/img/3WLtEWQqAun.jpg',
      music: '//matcdn.93vr.com/hsyj/music/3WLtEWQqAun.mp3',
      video: {
        thumb: '',
        src: ''
      },
      desc: ''
    },
    sV4AFvbXDiU: {
      title: '梦想起航',
      image: '//matcdn.93vr.com/hsyj/img/sV4AFvbXDiU.jpg',
      music: '//matcdn.93vr.com/hsyj/music/sV4AFvbXDiU.mp3',
      video: {
        thumb: '',
        src: ''
      },
      desc: ''
    },
    TI9H5U0OHCM: {
      title: '井冈山',
      image: '//matcdn.93vr.com/hsyj/img/TI9H5U0OHCM.jpg',
      music: '//matcdn.93vr.com/hsyj/music/TI9H5U0OHCM.mp3',
      video: {
        thumb: '',
        src: ''
      },
      desc: ''
    },
    CoOEYgwjYhu: {
      title: '瑞金',
      image: '//matcdn.93vr.com/hsyj/img/CoOEYgwjYhu.jpg',
      music: '//matcdn.93vr.com/hsyj/music/CoOEYgwjYhu.mp3',
      video: {
        thumb: '',
        src: ''
      },
      desc: ''
    },
    '71Sn0OhvL5k': {
      title: '鲁迅',
      image: '//matcdn.93vr.com/hsyj/img/71Sn0OhvL5k.jpg',
      music: '//matcdn.93vr.com/hsyj/music/71Sn0OhvL5k.mp3',
      video: {
        thumb: '',
        src: ''
      },
      desc: ''
    },
    jQX4SFnOVSt: {
      title: '抗美援朝',
      image: '//matcdn.93vr.com/hsyj/img/jQX4SFnOVSt.jpg',
      music: '//matcdn.93vr.com/hsyj/music/jQX4SFnOVSt.mp3',
      video: {
        thumb: '',
        src: ''
      },
      desc: ''
    },
    bXShzlYcLPo: {
      title: '沙家浜',
      image: '//matcdn.93vr.com/hsyj/img/bXShzlYcLPo.jpg',
      music: '//matcdn.93vr.com/hsyj/music/bXShzlYcLPo.mp3',
      video: {
        thumb: '',
        src: ''
      },
      desc: ''
    },
    ftbXXzFvtDo: {
      title: '毛主席',
      image: '//matcdn.93vr.com/hsyj/img/ftbXXzFvtDo.jpg',
      music: '//matcdn.93vr.com/hsyj/music/ftbXXzFvtDo.mp3',
      video: {
        thumb: '',
        src: ''
      },
      desc: ''
    },
    xjSgXJ6dyNb: {
      title: '毛泽东诗词瓶',
      image: '//matcdn.93vr.com/hsyj/img/xjSgXJ6dyNb.jpg',
      music: '//matcdn.93vr.com/hsyj/music/xjSgXJ6dyNb.mp3',
      video: {
        thumb: '',
        src: ''
      },
      desc: ''
    }
  }
}
